import { t } from 'ember-intl';
import QuestionsLoanTypesCard from 'tio-employee/components/questions/loan-types-card';
import QuestionsNumberedStep from 'tio-employee/components/questions/numbered-step';
import { VStack } from 'tio-ui/components/layout';
import SectionPanel from 'tio-ui/components/section-panel';
import {
  PhArrowDown,
  PhArrowsDownUp,
  PhThumbsUp,
  PhArrowsInSimple,
  PhProhibit,
  PhWarning,
  PhChartBar,
  PhCaretDoubleRight,
  PhListChecks,
} from 'ember-phosphor-icons';

const steps = [
  {
    number: 'number_one',
    title: 'questions_you_have.how_to_apply.submit_your_fafsa.default',
    points: [
      'questions_you_have.how_to_apply.submit_your_fafsa.point_1',
      'questions_you_have.how_to_apply.submit_your_fafsa.point_2',
      'questions_you_have.how_to_apply.submit_your_fafsa.point_3',
      'questions_you_have.how_to_apply.submit_your_fafsa.point_4',
      'questions_you_have.how_to_apply.submit_your_fafsa.point_5',
    ],
  },
  {
    number: 'number_two',
    title: 'questions_you_have.how_to_apply.receive_your_SAR.default',
    points: [
      'questions_you_have.how_to_apply.receive_your_SAR.point_1',
      'questions_you_have.how_to_apply.receive_your_SAR.point_2',
      'questions_you_have.how_to_apply.receive_your_SAR.point_3',
      'questions_you_have.how_to_apply.receive_your_SAR.point_4',
    ],
  },
  {
    number: 'number_three',
    title: 'questions_you_have.how_to_apply.check_application_requirements.default',
    points: [
      'questions_you_have.how_to_apply.check_application_requirements.point_1',
      'questions_you_have.how_to_apply.check_application_requirements.point_2',
    ],
  },
  {
    number: 'number_four',
    title: 'questions_you_have.how_to_apply.receive_award_letter.default',
    points: [
      'questions_you_have.how_to_apply.receive_award_letter.point_1',
      'questions_you_have.how_to_apply.receive_award_letter.point_2',
      'questions_you_have.how_to_apply.receive_award_letter.point_3',
    ],
  },
  {
    number: 'number_five',
    title: 'questions_you_have.how_to_apply.entrance_counseling.default',
    points: ['questions_you_have.how_to_apply.entrance_counseling.point_1'],
  },
  {
    number: 'number_six',
    title: 'questions_you_have.how_to_apply.accept_fa_package.default',
    points: [
      'questions_you_have.how_to_apply.accept_fa_package.point_1',
      'questions_you_have.how_to_apply.accept_fa_package.point_2',
      'questions_you_have.how_to_apply.accept_fa_package.point_3',
    ],
  },
];

<template>
  <VStack class="gap-6">
    <SectionPanel
      @headingLevel={{3}}
      @icon={{PhThumbsUp}}
      @iconColor="green"
      @title={{t "questions_you_have.types_of_student_loans.pros.pros_federal"}}
    >
      <:body>
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          <QuestionsLoanTypesCard
            @icon={{PhArrowDown}}
            @label={{t "questions_you_have.types_of_student_loans.pros.lower_interest"}}
          />
          <QuestionsLoanTypesCard
            @icon={{PhArrowsDownUp}}
            @label={{t "questions_you_have.types_of_student_loans.pros.repayment_options"}}
          />
          <QuestionsLoanTypesCard
            @icon={{PhThumbsUp}}
            @label={{t "questions_you_have.types_of_student_loans.pros.check_or_collateral"}}
          />
          <QuestionsLoanTypesCard
            @icon={{PhArrowsInSimple}}
            @label={{t "questions_you_have.types_of_student_loans.pros.consolidation"}}
          />
          <QuestionsLoanTypesCard
            @icon={{PhProhibit}}
            @label={{t "questions_you_have.types_of_student_loans.pros.do_not_accrue"}}
          />
        </div>
      </:body>
    </SectionPanel>

    <SectionPanel
      @headingLevel={{3}}
      @icon={{PhWarning}}
      @iconColor="amber"
      @title={{t "questions_you_have.types_of_student_loans.cons.cons_federal"}}
    >
      <:body>
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          <QuestionsLoanTypesCard
            @icon={{PhWarning}}
            @label={{t "questions_you_have.types_of_student_loans.cons.subsidized_limit"}}
          />
          <QuestionsLoanTypesCard
            @icon={{PhChartBar}}
            @label={{t "questions_you_have.types_of_student_loans.cons.unsubsidized_limit"}}
          />
          <QuestionsLoanTypesCard
            @icon={{PhCaretDoubleRight}}
            @label={{t "questions_you_have.types_of_student_loans.cons.higher_interest"}}
          />
        </div>
      </:body>
    </SectionPanel>

    <SectionPanel
      @headingLevel={{3}}
      @icon={{PhListChecks}}
      @iconColor="violet"
      @title={{t "questions_you_have.how_to_apply.default"}}
    >
      <:body>
        <VStack class="gap-6">
          {{#each steps as |step|}}
            <QuestionsNumberedStep
              @number={{step.number}}
              @title={{step.title}}
              @points={{step.points}}
            />
          {{/each}}
        </VStack>
      </:body>
    </SectionPanel>
  </VStack>
</template>
